import React, { useCallback, useMemo, useState } from 'react';
import AppButton from '../../atoms/AppButton/AppButton';
import { RiArrowDownSLine, RiArrowUpSLine, RiSearchLine } from '@remixicon/react';

export interface AppSelectItemProp {
  value: string;
  label: string;
}

interface AppSelectProps {
  value: AppSelectItemProp[];
  onChange: (value: AppSelectItemProp[]) => void;
  options: AppSelectItemProp[];
  isSearchable?: boolean;
}

export const AppMultiselect = ({ isSearchable = false, options, onChange, value }: AppSelectProps) => {
  const [valueCheck, setValueCheck] = useState(value);
  const [search, setSearch] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);


  const onChangeCheck = (value: string, label: string) => {
    const newValue = valueCheck.length > 0
      ? valueCheck.some(i => i.value === value)
        ? valueCheck.filter(i => i.value !== value)
        : [...valueCheck, { value, label }]
      : [...valueCheck, { value, label }];

    setValueCheck(newValue);
    onChange(newValue);
  };

  const selectAll = (hasCheckAll: boolean) => {
    setValueCheck(hasCheckAll ? options : []);
    onChange(hasCheckAll ? options : []);
  };

  const onChangeSearch = (value: string) => setSearch(value);


  const optionsFiltered = useCallback(() => {
    if (search === '') return options;

    return options.filter(option => option.label.toLowerCase().includes(search));

  }, [search, options]);

  const validCheck = valueCheck.length > 0 ? valueCheck.map(i => i.value) : [];
  const buttonSelectedTitle = useMemo(() => {
    const firstOptions = valueCheck.slice(0, 3).filter(i => i.value).map(v => v.label).join(', ');
    const differenceSelected = valueCheck.slice(3, validCheck.length).length;
    return `${firstOptions}${differenceSelected > 0 ? `, +${differenceSelected}` : ''}`;
  }, [valueCheck]);

  return (
    <div className="flex flex-col relative min-full">
      <AppButton
        onBlur={() => !mouseEnter && setShowOptions(false)}
        state={'ghost'}
        title={valueCheck.length > 0 ? buttonSelectedTitle : 'Seleccionar'}
        className={'bg-white'}
        onClick={() => setShowOptions(!showOptions)}
        iconRight={showOptions ? <RiArrowUpSLine
          size={20} color="#475569"
        /> : <RiArrowDownSLine size={20} color="#475569" />}
      />

      {
        showOptions && <div
          onMouseOver={() => setMouseEnter(true)}
          onMouseOut={() => setMouseEnter(false)}
          onBlur={() => !mouseEnter && setShowOptions(false)}
          className={'bg-white rounded-lg mt-1 shadow-sm absolute top-11 z-10 w-full'}>

          {
            isSearchable && <div className="flex w-full items-center px-3 py-2 gap-3">
              <RiSearchLine size={20} color="#94A3B8" />
              <input type="text" placeholder={'Buscar...'} className="w-full outline-0" value={search}
                     onChange={(e) => onChangeSearch(e.target.value)} />
            </div>
          }

          <hr />

          <ul className="w-full flex items-center p-3 text-sm text-gray-700 border-t-0">
            <input id="selectAll" checked={valueCheck.length === options.length}
                   onChange={() => selectAll(!(valueCheck.length === options.length))}
                   type="checkbox" value=""
                   className="w-4 h-4 text-teal-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-teal-500 dark:focus:ring-teal-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 accent-green-700" />
            <div className="flex flex-col">
              <label htmlFor="selectAll" className="ms-2 text-sm font-medium text-black cursor-pointer">Seleccionar
                todas</label>
            </div>
          </ul>
          <hr />


          {optionsFiltered().length === 0
            ? (
              <h2 className="p-3">Sin resultados</h2>
            )
            : (
              <div className="max-h-48 w-auto overflow-y-scroll">


                {optionsFiltered().map(item => (
                  <ul key={item.value} className="w-full flex items-center p-3 text-sm text-gray-700 border-t-0">
                    <input id={item.value} checked={validCheck.includes(item.value)}
                           onChange={() => onChangeCheck(item.value, item.label)}
                           type="checkbox" value=""
                           className="w-4 h-4 text-teal-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-teal-500 dark:focus:ring-teal-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 accent-green-700" />
                    <div className="flex flex-col">
                      <label htmlFor={item.value} className="ms-2 text-sm font-medium text-black">{item.label}</label>
                    </div>
                  </ul>
                ))}
              </div>
            )}
        </div>
      }


    </div>
  );
};
